import { LanguageManager, Locale } from "@lib/titan2/dist/game/manager/LanguageManager";
import { ViewProperties } from "../../../utils/ViewProperties";
/**
 * Game-specific properties for the message bar.
 */
export class GameMessageBarProperties extends ViewProperties {
    getMaxLength() {
        const locale = LanguageManager.getInstance().getLocale();
        return this.maxLength.get(locale) ?? this.maxLength.get(Locale.ENGLISH);
    }
}
//# sourceMappingURL=GameMessageBarProperties.js.map